<div class="iti-banner">
    <div class="iti-banner-logo">
        <img src="assets/images/logo.png">
    </div>
    <div class="iti-banner-info">
        Results as on {{currentDate | date: 'MMM dd, yyyy ' }} at {{currentDate | date:  'h:mm a'}}
        <button
            color="primary"
            mat-icon-button
            (click)="reloadPage()"
        >
            <mat-icon class="mat-icon-28">sync</mat-icon>
        </button>
    </div>
</div>
